(function () {
  'use strict';

  var configElement = document.getElementById('BxgyFreeGiftConfig');
  if (!configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.warn('BXGY free gift config could not be parsed.', error);
    return;
  }

  if (!Array.isArray(config.offers)) return;

  var giftMarker = '_bxgy_free_gift';
  var offerMarker = '_bxgy_offer_id';
  var scheduleTimeZone = typeof config.scheduleTimeZone === 'string' ? config.scheduleTimeZone.trim() : '';
  var storeTimeFormatter = null;
  var hasWarnedInvalidTimeZone = false;
  var configuredOffers = config.offers.filter(isConfiguredOffer).map(normalizeOffer);
  var activeOffers = [];
  var activeOfferIds = [];
  var currentCollectionId = config.currentCollectionId ? String(config.currentCollectionId) : '';
  var pendingAddOfferIds = {};
  var isSyncing = false;
  var syncTimer = null;
  var scheduleTimer = null;
  var pendingSync = false;
  var lastAddFailureByOffer = {};
  var addFailureCooldown = 30000;
  var cartMutationPattern = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function isConfiguredOffer(offer) {
    return Boolean(
      offer &&
      offer.enabled &&
      offer.id &&
      offer.gift &&
      offer.gift.variantId &&
      Array.isArray(offer.qualifierProductIds) &&
      offer.qualifierProductIds.length
    );
  }

  function parseScheduleValue(value) {
    var match = typeof value === 'string' && value.trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/);
    if (!match) return null;

    var year = Number(match[1]);
    var month = Number(match[2]);
    var day = Number(match[3]);
    var hour = Number(match[4]);
    var minute = Number(match[5]);
    var validationDate = new Date(Date.UTC(year, month - 1, day, hour, minute));

    if (
      validationDate.getUTCFullYear() !== year ||
      validationDate.getUTCMonth() !== month - 1 ||
      validationDate.getUTCDate() !== day ||
      validationDate.getUTCHours() !== hour ||
      validationDate.getUTCMinutes() !== minute
    ) {
      return null;
    }

    return Number(match[1] + match[2] + match[3] + match[4] + match[5]);
  }

  function getStoreTimeKey() {
    if (!scheduleTimeZone || typeof Intl === 'undefined' || typeof Intl.DateTimeFormat !== 'function') return null;

    try {
      if (!storeTimeFormatter) {
        storeTimeFormatter = new Intl.DateTimeFormat('en-CA', {
          timeZone: scheduleTimeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23'
        });
      }

      var parts = {};
      storeTimeFormatter.formatToParts(new Date()).forEach(function (part) {
        if (part.type !== 'literal') parts[part.type] = part.value;
      });

      return Number(parts.year + parts.month + parts.day + parts.hour + parts.minute);
    } catch (error) {
      if (!hasWarnedInvalidTimeZone) {
        console.warn('BXGY offers require a valid IANA store time zone.', error);
        hasWarnedInvalidTimeZone = true;
      }
      return null;
    }
  }

  function isOfferScheduled(offer, storeTimeKey) {
    return Boolean(
      storeTimeKey &&
      offer.scheduleStartKey &&
      offer.scheduleEndKey &&
      offer.scheduleEndKey > offer.scheduleStartKey &&
      storeTimeKey >= offer.scheduleStartKey &&
      storeTimeKey < offer.scheduleEndKey
    );
  }

  function refreshActiveOffers() {
    var storeTimeKey = getStoreTimeKey();
    activeOffers = configuredOffers.filter(function (offer) {
      return isOfferScheduled(offer, storeTimeKey);
    });
    activeOfferIds = activeOffers.map(function (offer) {
      return offer.id;
    });
  }

  function normalizeOffer(offer) {
    var requiredCollectionId = offer.requiredCollectionId ? String(offer.requiredCollectionId) : '';
    var schedule = offer.schedule || {};

    return {
      id: String(offer.id),
      name: offer.name || offer.id,
      qualifierProductIds: offer.qualifierProductIds.map(String),
      requiredCollectionId: requiredCollectionId,
      scheduleStartKey: parseScheduleValue(schedule.start),
      scheduleEndKey: parseScheduleValue(schedule.end),
      giftProductId: String(offer.gift.productId),
      giftVariantId: Number(offer.gift.variantId),
      giftQuantity: Math.max(1, Number(offer.giftQuantity) || 1),
      giftProperties: Object.assign({}, offer.giftProperties || {}, {
        '_bxgy_free_gift': 'true',
        '_bxgy_offer_id': String(offer.id)
      })
    };
  }

  function normalizeUrl(url) {
    var rawUrl = typeof url === 'string' ? url : url && url.url;
    if (!rawUrl) return '';

    try {
      var parsedUrl = new URL(rawUrl, window.location.origin);
      return parsedUrl.pathname + parsedUrl.search;
    } catch (error) {
      return rawUrl;
    }
  }

  function isCartMutation(url) {
    return cartMutationPattern.test(normalizeUrl(url));
  }

  function isCartAdd(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(normalizeUrl(url));
  }

  function requestJson(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () {
          return {};
        }).then(function (payload) {
          var message = payload.description || payload.message || response.statusText;
          throw new Error(message);
        });
      }

      return response.json();
    });
  }

  function getCart() {
    return requestJson(config.cartUrl, {
      headers: {
        Accept: 'application/json'
      }
    });
  }

  function getProperties(item) {
    return item && item.properties ? item.properties : {};
  }

  function hasGiftMarker(item) {
    return getProperties(item)[giftMarker] === 'true';
  }

  function getOfferId(item) {
    return String(getProperties(item)[offerMarker] || '');
  }

  function isManagedGiftItem(item) {
    return hasGiftMarker(item);
  }

  function isQualifierItemForOffer(item, offer) {
    if (!item || hasGiftMarker(item)) return false;
    return offer.qualifierProductIds.indexOf(String(item.product_id)) !== -1;
  }

  function getQualifierQuantityForOffer(items, offer) {
    return items.reduce(function (quantity, item) {
      if (!isQualifierItemForOffer(item, offer)) return quantity;
      return quantity + Math.max(0, Number(item.quantity) || 0);
    }, 0);
  }

  function isCurrentGiftItemForOffer(item, offer) {
    if (!isManagedGiftItem(item)) return false;
    if (getOfferId(item) !== offer.id) return false;
    return String(item.product_id) === offer.giftProductId || Number(item.variant_id) === offer.giftVariantId;
  }

  function updateOfferCallouts() {
    document.querySelectorAll('[data-bxgy-offer-id]').forEach(function (callout) {
      var offerId = String(callout.getAttribute('data-bxgy-offer-id') || '');
      callout.hidden = activeOfferIds.indexOf(offerId) === -1;
    });

    document.querySelectorAll('[data-bxgy-callouts]').forEach(function (calloutGroup) {
      calloutGroup.hidden = !calloutGroup.querySelector('[data-bxgy-offer-id]:not([hidden])');
    });
  }

  function getAddedItems(payload) {
    if (!payload || typeof payload !== 'object') return [];
    return Array.isArray(payload.items) ? payload.items : [payload];
  }

  function allowGatedOffersForCartAdd(payload) {
    refreshActiveOffers();
    var addedProductIds = getAddedItems(payload).map(function (item) {
      return item && item.product_id ? String(item.product_id) : '';
    }).filter(Boolean);

    activeOffers.forEach(function (offer) {
      if (!offer.requiredCollectionId || offer.requiredCollectionId !== currentCollectionId) return;

      var addedQualifier = !addedProductIds.length || addedProductIds.some(function (productId) {
        return offer.qualifierProductIds.indexOf(productId) !== -1;
      });

      if (addedQualifier) pendingAddOfferIds[offer.id] = true;
    });
  }

  function handleSuccessfulCartAdd(response) {
    if (!response || typeof response.clone !== 'function') {
      allowGatedOffersForCartAdd();
      scheduleSync();
      return;
    }

    response.clone().json().then(function (payload) {
      allowGatedOffersForCartAdd(payload);
    }).catch(function () {
      allowGatedOffersForCartAdd();
    }).then(function () {
      scheduleSync();
    });
  }

  function canAddGift(offer, allowedOfferIds) {
    return !offer.requiredCollectionId || Boolean(allowedOfferIds[offer.id]);
  }

  function addGift(offer, quantity) {
    if (!isOfferScheduled(offer, getStoreTimeKey())) return Promise.resolve();

    var now = Date.now();
    var lastFailureAt = lastAddFailureByOffer[offer.id] || 0;

    if (lastFailureAt && now - lastFailureAt < addFailureCooldown) {
      return Promise.resolve();
    }

    return requestJson(config.cartAddUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: offer.giftVariantId,
            quantity: quantity,
            properties: offer.giftProperties
          }
        ]
      })
    }).catch(function (error) {
      lastAddFailureByOffer[offer.id] = Date.now();
      console.warn('BXGY free gift could not be added for ' + offer.name + '.', error);
    });
  }

  function changeLine(item, quantity) {
    return requestJson(config.cartChangeUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: item.key,
        quantity: quantity
      })
    });
  }

  function updateVisibleCart(cart) {
    if (!cart) return;

    if (typeof window.updateCartCount === 'function') {
      window.updateCartCount(cart.item_count);
    }

    document.querySelectorAll('[data-cart-count]').forEach(function (element) {
      if (cart.item_count === 0) {
        element.textContent = '';
        element.style.display = 'none';
      } else {
        element.textContent = cart.item_count;
        element.style.display = '';
      }
    });

    document.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: {
        cart: cart,
        source: 'bxgy-free-gift'
      }
    }));
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: {
        source: 'bxgy-free-gift'
      }
    }));

    if (window.location.pathname.indexOf('/cart') > -1 && typeof window.cartPageUpdate === 'function') {
      window.cartPageUpdate(cart);
      return;
    }

    if (typeof window.buildCart === 'function' && document.querySelector('[data-drawer-body]')) {
      var drawerIsOpen = document.body.classList.contains('side_Drawer_open') || document.body.classList.contains('yv_side_Drawer_open');
      window.buildCart(cart, drawerIsOpen);
    }
  }

  function reconcileCart(cart, allowedOfferIds) {
    var managedGiftLines = cart.items.filter(isManagedGiftItem);
    var actions = Promise.resolve();
    var changed = false;

    function queueCartChange(callback) {
      changed = true;
      actions = actions.then(callback);
    }

    activeOffers.forEach(function (offer) {
      var qualifierQuantity = getQualifierQuantityForOffer(cart.items, offer);
      var targetGiftQuantity = qualifierQuantity * offer.giftQuantity;
      var offerGiftLines = managedGiftLines.filter(function (item) {
        return getOfferId(item) === offer.id;
      });
      var currentGiftLines = offerGiftLines.filter(function (item) {
        return isCurrentGiftItemForOffer(item, offer);
      });

      offerGiftLines.forEach(function (item) {
        if (isCurrentGiftItemForOffer(item, offer)) return;
        queueCartChange(function () {
          return changeLine(item, 0);
        });
      });

      if (targetGiftQuantity > 0) {
        if (!currentGiftLines.length && canAddGift(offer, allowedOfferIds)) {
          queueCartChange(function () {
            return addGift(offer, targetGiftQuantity);
          });
        }

        currentGiftLines.forEach(function (item, index) {
          if (index === 0 && item.quantity === targetGiftQuantity) return;
          queueCartChange(function () {
            return changeLine(item, index === 0 ? targetGiftQuantity : 0);
          });
        });
      } else {
        currentGiftLines.forEach(function (item) {
          queueCartChange(function () {
            return changeLine(item, 0);
          });
        });
      }
    });

    managedGiftLines.forEach(function (item) {
      if (activeOfferIds.indexOf(getOfferId(item)) !== -1) return;
      queueCartChange(function () {
        return changeLine(item, 0);
      });
    });

    return actions.then(function () {
      if (!changed) {
        return {
          cart: cart,
          changed: false
        };
      }

      return getCart().then(function (updatedCart) {
        return {
          cart: updatedCart,
          changed: true
        };
      });
    });
  }

  function syncCart() {
    if (isSyncing) {
      pendingSync = true;
      return;
    }

    isSyncing = true;
    pendingSync = false;
    refreshActiveOffers();
    updateOfferCallouts();
    var allowedOfferIds = pendingAddOfferIds;
    pendingAddOfferIds = {};

    getCart()
      .then(function (cart) {
        return reconcileCart(cart, allowedOfferIds);
      })
      .then(function (result) {
        if (result.changed) updateVisibleCart(result.cart);
      })
      .catch(function (error) {
        Object.keys(allowedOfferIds).forEach(function (offerId) {
          pendingAddOfferIds[offerId] = true;
        });
        console.warn('BXGY free gift sync failed.', error);
      })
      .finally(function () {
        isSyncing = false;
        if (pendingSync) scheduleSync(100);
      });
  }

  function scheduleSync(delay) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncCart, typeof delay === 'number' ? delay : 200);
  }

  function scheduleNextScheduleCheck() {
    window.clearTimeout(scheduleTimer);

    var storeTimeKey = getStoreTimeKey();
    var hasScheduleThatHasNotEnded = configuredOffers.some(function (offer) {
      return Boolean(
        storeTimeKey &&
        offer.scheduleStartKey &&
        offer.scheduleEndKey &&
        offer.scheduleEndKey > offer.scheduleStartKey &&
        storeTimeKey < offer.scheduleEndKey
      );
    });

    if (!hasScheduleThatHasNotEnded) return;

    var delayUntilNextMinute = 60050 - (Date.now() % 60000);
    scheduleTimer = window.setTimeout(function () {
      var previousActiveOfferIds = activeOfferIds.slice();
      refreshActiveOffers();
      updateOfferCallouts();

      var scheduleChanged = previousActiveOfferIds.length !== activeOfferIds.length || previousActiveOfferIds.some(function (offerId) {
        return activeOfferIds.indexOf(offerId) === -1;
      });

      if (scheduleChanged) scheduleSync(0);
      scheduleNextScheduleCheck();
    }, delayUntilNextMinute);
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function () {
      var requestUrl = arguments[0];
      var responsePromise = nativeFetch.apply(this, arguments);

      if (isCartMutation(requestUrl)) {
        responsePromise.then(function (response) {
          if (!response || !response.ok) return;
          if (isCartAdd(requestUrl)) {
            handleSuccessfulCartAdd(response);
          } else {
            scheduleSync();
          }
        }).catch(function () {});
      }

      return responsePromise;
    };
  }

  if (window.jQuery && typeof window.jQuery === 'function') {
    window.jQuery(document).ajaxComplete(function (_event, xhr, settings) {
      if (xhr && xhr.status >= 200 && xhr.status < 300 && settings && isCartMutation(settings.url)) {
        if (isCartAdd(settings.url)) {
          var payload = xhr.responseJSON;
          if (!payload && xhr.responseText) {
            try {
              payload = JSON.parse(xhr.responseText);
            } catch (error) {}
          }
          allowGatedOffersForCartAdd(payload);
        }
        scheduleSync();
      }
    });
  }

  document.addEventListener('cart:refresh', function (event) {
    if (event && event.detail && event.detail.source === 'bxgy-free-gift') return;
    scheduleSync();
  });

  refreshActiveOffers();
  updateOfferCallouts();
  scheduleNextScheduleCheck();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleSync(0);
    }, { once: true });
  } else {
    scheduleSync(0);
  }
})();
